import { voipReducer } from './voipReducer';
import { voipReportReducer } from './voipReportReducer';

const voipReducers = {
  voip: voipReducer,
  voipReport: voipReportReducer,
};

export default voipReducers;